import { render, staticRenderFns } from "./StatusChip.vue?vue&type=template&id=c70ca130&"
import script from "./StatusChip.vue?vue&type=script&lang=ts&"
export * from "./StatusChip.vue?vue&type=script&lang=ts&"
import style0 from "./StatusChip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports